import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {BimModel} from "../../bim-model.interface";
import {SafeUrl} from "@angular/platform-browser";
import {Observable, of, BehaviorSubject, Subject} from "rxjs";
import {finalize, takeUntil} from "rxjs/operators";
import {ThumbnailData} from "../../bim-model-thumbnail.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
export interface BimModelWithThumbnailObservable extends BimModel {
  thumbnail$?: Observable<ThumbnailData>;
}
@UntilDestroy()
@Component({
  selector: 'mydocma-co-bim-model-modal-item',
  templateUrl: './bim-model-selection-modal-item.component.html',
  styleUrls: ['./bim-model-selection-modal-item.component.scss'],
})
export class BimModelsModalItemComponent implements OnInit, OnDestroy {
  @Input() bimModel: BimModelWithThumbnailObservable;
  @Input() isSelected: boolean;
  @Output() selectedModelEvent = new EventEmitter<BimModel>();

  bimImg$: BehaviorSubject<SafeUrl | null> = new BehaviorSubject<ThumbnailData>(null);
  loading = true;


  constructor() {
  }

  ngOnInit() {
    if (this.bimModel?.thumbnail$) {
      this.bimModel?.thumbnail$.pipe(
        untilDestroyed(this),
        finalize(() => (this.loading = false)),
      ).subscribe((result) => {
        this.bimImg$.next(result.url)
      });
    } else {
      this.loading = false;
      this.bimImg$.next(null)
    }
  }

  onModelSelect() {
    this.selectedModelEvent.emit(this.bimModel);
  }

  ngOnDestroy(): void {

  }

}
